






















































import { defineComponent, ref, watch } from '@vue/composition-api';
import { usePagination } from '@/bundles/BaseTable/composables/usePagination';
import { useAdClient } from '@/bundles/Ad/composables/useAdClient';

import AdClientsListTable from '@/bundles/Ad/components/AdClientsListTable.vue';
import AdClientCreateForm from '@/bundles/Ad/components/AdClientCreateForm.vue';

export default defineComponent({
  name: 'AdAdminClients',

  components: {
    AdClientsListTable,
    AdClientCreateForm,
  },

  setup () {
    const { fetch, listLoading, adClientItems, total } = useAdClient();
    const { tableOptions, pageOffset, optionsChangeEventHandler } = usePagination();
    watch(() => tableOptions, () => fetchWrapper(), { deep: true, immediate: true });
    async function fetchWrapper () {
      const wrapper = document.querySelector('.base-table-wrapper .v-data-table__wrapper')
      if (wrapper) {
        wrapper.scrollTop = 0
      }
      await fetch();
    }

    const showCreateForm = ref(false);

    return {
      listLoading,
      adClientItems,
      total,
      tableOptions,
      pageOffset,
      showCreateForm,
      optionsChangeEventHandler,
      fetchWrapper
    };
  }
});
